import React, {Fragment, Suspense} from 'react';
import MasterLayout from "../../components/MasterLayout/MasterLayout";
import LazyLoader from "../../components/MasterLayout/LazyLoader";
import UserLoginHistoryList from '../../components/UserManagement/UserLoginHistoryList';
const UserLoginHistoryListPage = () => {
    return (
        <Fragment>
            <MasterLayout>
                <Suspense fallback={<LazyLoader/>}>
                    <UserLoginHistoryList/>
                </Suspense>
            </MasterLayout>
        </Fragment>
    );
};
export default UserLoginHistoryListPage;